export default __webpack_public_path__ + "static/event-33a499efadbe752878077d41eb90f221.svg";